import { ApiBase } from 'utils/api';
import { forceDownload, objectToFormData } from 'utils/common';


export default class PhotoApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    add = (id: number, albums: {name: string, text: string, photos: File[]}[]) => this.base.axios
        .post(`/api/cars/${id}/photos`,
            objectToFormData({albums}),
            {headers: {'Content-Type': 'multipart/form-data'}}
        );

    get = (id: number, album: string) => this.base.axios
        .get(`/api/cars/${id}/photos/${album}`)
        .then(res => res.data);

    download = (id: number) => this.base.axios
        .get(`/api/cars/${id}/photos/download`, {responseType: 'blob',})
        .then(forceDownload);

    move = (path: string, album: string) => this.base.axios
        .put(`/api/cars/photos/move`, {}, {params: {path, album}})
        .then(res => res.data);

    rotate = (path: string, direction: string) => this.base.axios
        .put(`/api/cars/photos/rotate`, {}, {params: {path, direction}});

    remove = (paths: string[]) => this.base.axios
        .delete(`/api/cars/photos`, {params: {paths}});
}
